export type getAWSRowCountParams = {
  pageSize?: number;
  DEFAULT_PAGE_SIZE: number;
  page: number;
  hasMore: boolean;
  array: unknown[];
};

/**
 * Basically the DataGrid relies on the rowCount to know how many
 * rows to show and it needs a bit of further processing to tell
 * how many rows there actually are and display them correctly
 */

export const getAWSRowCount = ({ pageSize, DEFAULT_PAGE_SIZE, page, hasMore, array }: getAWSRowCountParams): number => {
  const actualPageSize = pageSize ?? DEFAULT_PAGE_SIZE;
  const actualPageNumber = page + 1;
  if (hasMore) {
    if (array.length > 0) {
      return array.length * actualPageNumber + 1;
    }
    return actualPageSize * actualPageNumber + 1;
  }
  if (page > 0) {
    return page * actualPageSize + array.length;
  }
  return array.length;
};

export interface AwsPagination {
  inputToken: string;
  outputToken: string;
  itemsKey: string;
}

/** Fetch every page for selectors and operations that need the complete collection. */
export const collectAwsPages = async (
  fetchPage: (input: Record<string, unknown>) => Promise<Record<string, unknown>>,
  input: Record<string, unknown>,
  { inputToken, outputToken, itemsKey }: AwsPagination,
): Promise<Record<string, unknown>> => {
  let page = await fetchPage(input);
  const items: unknown[] = [];
  const seenTokens = new Set<unknown>();
  while (true) {
    const pageItems = page[itemsKey];
    if (Array.isArray(pageItems)) items.push(...pageItems);
    const token = page[outputToken];
    if (!token) return { ...page, [itemsKey]: items };
    if (seenTokens.has(token)) throw new Error('The service returned a repeated pagination token. Refresh and retry.');
    seenTokens.add(token);
    page = await fetchPage({ ...input, [inputToken]: token });
  }
};
